// import React, { useEffect, useState, useRef } from 'react';
// import CircularProgress from '@mui/material/CircularProgress';
// import Box from '@mui/material/Box';
// import PaginationTable from '../../pagination/Pagination4';

// const KeyRegisterAllotFPS_data = async (parms) => {
//   const response = await fetch(`${process.env.REACT_APP_URL_ALLOTMENT}/KeyRegister/getfpsKeyRegisterCardsList`, {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify(parms),
//   });

//   if (!response.ok) throw new Error('Failed to fetch data');
//   return response.json();
// };

// const KeyRegCards_FPS_Cards = ({ month, year, dist_code, afso_code, fps_id }) => {
//   const [reportData, setReportData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [tabHeading, setTabHeading] = useState(null);

//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(50);

//   const fpscardstab = useRef(null);
//   const [totals, setTotals] = useState([]);
//   const [searchQuery, setSearchQuery] = useState('');

//   // Calculate totals dynamically
//   const calculateTotals = (data) => {
//     if (!data || data.length === 0) {
//       setTotals([]);
//       return;
//     }

//     const columnCount = data[0].lst.length;
//     const columnTotals = new Array(columnCount).fill(0);

//     data.forEach(item => {
//       item.lst.forEach((colItem, colIndex) => {
//         columnTotals[colIndex] += parseFloat(colItem.qty_1) || 0;
//       });
//     });

//     setTotals(columnTotals);
//   };

//   useEffect(() => {
//     const getData = async () => {
//       try {
//         const response_data = await KeyRegisterAllotFPS_data({ month, year, dist_code, afso_code, fps_id });

//         setTabHeading(response_data.heading);

//         if (response_data.data && response_data.data.length > 0) {
//           setReportData(response_data.data);
//         } else {
//           setReportData([]);
//         }

//       } catch (errorr) {
//         setError(errorr);
//       } finally {
//         setLoading(false);
//       }
//     };

//     getData();
//   }, [month, year, dist_code, afso_code, fps_id]);

//   // Reset page on search
//   useEffect(() => {
//     setPage(0);
//   }, [searchQuery]);

//   // FILTER: Searching by RC ID
//   const filteredData = reportData.filter(item =>
//     (item?.rc_id || "").toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   // Recalculate totals based on filtered data
//   useEffect(() => {
//     calculateTotals(filteredData);
//   }, [filteredData]);

//   // Pagination logic
//   const paginatedData =
//     rowsPerPage >= filteredData.length
//       ? filteredData
//       : filteredData.slice(page * rowsPerPage, (page + 1) * rowsPerPage);

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (value) => {
//     if (value === 'all') {
//       setRowsPerPage(reportData.length);
//     } else {
//       setRowsPerPage(parseInt(value, 10));
//     }
//     setPage(0);
//   };

//   // Auto-scroll
//   useEffect(() => {
//     if (!loading && !error && reportData.length > 0 && fpscardstab.current) {
//       fpscardstab.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     }
//   }, [loading, error, reportData]);

//   if (loading) {
//     return (
//       <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//         <Box sx={{ display: 'flex' }}>
//           <CircularProgress />
//         </Box>
//       </div>
//     );
//   }

//   if (error) {
//     return <div className="mainhead" align="center">Internal Error</div>;
//   }

//   if (filteredData.length === 0) {
//     return <div className="mainhead" align="center">
//       No Data found
//     </div>;
//   }

//   return (
//     <>
//      <div 
//   style={{ 
//     display: 'flex', 
//     alignItems: 'center',
//     justifyContent: 'space-between', 
//     width: '90%', 
//     margin: '0 auto',
//     marginBottom: '20px'
//   }}
// >
//   {/* Pagination (Center) */}
//   <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
//     <PaginationTable
//       count={filteredData.length}
//       rowsPerPage={rowsPerPage}
//       page={page}
//       onPageChange={handleChangePage}
//       onRowsPerPageChange={handleChangeRowsPerPage}
//     />
//   </div>

//   {/* Search (Right Side) */}
//   <div>
//     <input
//       type="text"
//       placeholder="Search RC ID."
//       value={searchQuery}
//       onChange={(e) => setSearchQuery(e.target.value)}
//       style={{ padding: '8px', width: '300px' }}
//     />
//   </div>
// </div>


//       {/* Table */}
//       <table ref={fpscardstab} align="center" width="90%" border={1}>
//         <thead>
//           <tr className="tableheader">
//             <th colSpan={9}>{tabHeading}</th>
//           </tr>
//           <tr className="tableheader">
//             <th rowSpan={2}>Sl.No</th>
//             <th rowSpan={2}>RC Id</th>
//             <th rowSpan={2}>Family Head</th>
//             <th rowSpan={2}>Scheme</th>
//             <th rowSpan={2}>Units</th>
//              <th colSpan={reportData[0].lst.length}>Entitlement</th> 
//           </tr>
//           <tr className="tableheader">
//             {reportData[0].lst.map((item) => (
//               <th key={item.comm_name_en}>{item.comm_name_en}</th>
//             ))}
//           </tr>
//         </thead>

//         <tbody>
//           {paginatedData.length > 0 ? (
//             paginatedData.map((item, index) => (
//               <tr key={item.fps_id}>
//                 <td style={{ textAlign: 'center' }}>
//                   {index + 1 + page * rowsPerPage}
//                 </td>
//                 <td style={{ textAlign: 'left' }}>{item.rc_id}</td>
//                 <td style={{ textAlign: 'left' }}>{item.family_head}</td>
//                 <td style={{ textAlign: 'left' }}>{item.scheme_name_en}</td>
//                 <td style={{ textAlign: 'right' }}>{item.total_units}</td>

//                 {item.lst.map((item1, idx) => (
//                   <td key={idx} style={{ textAlign: 'right' }}>{item1.qty_1}</td>
//                 ))}
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td colSpan={4 + reportData[0].lst.length} style={{ textAlign: 'center', padding: '20px' }}>
//                 No results found for "{searchQuery}"
//               </td>
//             </tr>
//           )}
//         </tbody>

//         {/* Totals */}
//         <tfoot>
//           <tr className="tableheader">
//             <td colSpan={5}>Total</td>
//             {totals.map((total, index) => (
//               <td style={{ textAlign: 'right', fontWeight: 'bold' }} key={index}>
//                 {total.toFixed(3)}
//               </td>
//             ))}
//           </tr>
//         </tfoot>
//       </table>

//       <br /><br /><br /><br /><br /><br />
//     </>
//   );
// };

// export default KeyRegCards_FPS_Cards;

//========================================================================





// import React, { useEffect, useState, useMemo } from 'react';
// import CircularProgress from '@mui/material/CircularProgress';
// import Box from '@mui/material/Box';
// import PaginationTable from '../../pagination/Pagination4';

// const fetchData = async (params) => {
//   const res = await fetch(
//     `${process.env.REACT_APP_URL_ALLOTMENT}/KeyRegister/getfpsKeyRegisterCardsList`,
//     {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(params),
//     }
//   );

//   if (!res.ok) throw new Error("API Error");
//   return res.json();
// };

// const KeyRegisterTable = ({ month, year, dist_code, afso_code, fps_id }) => {

//   const [data, setData] = useState([]);
//   const [columns, setColumns] = useState([]);
//   const [heading, setHeading] = useState("");
//   const [loading, setLoading] = useState(true);

//   //  Pagination + Search
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(50);
//   const [search, setSearch] = useState("");

//   //  Get Commodity Columns
//   const getColumns = (data) => {
//     const cols = new Set();
//     data.forEach(row => {
//       Object.keys(row).forEach(key => {
//         if (key.includes("(")) cols.add(key);
//       });
//     });
//     return Array.from(cols);
//   };

//   //  Fetch API
//   useEffect(() => {
//     const load = async () => {
//       try {
//         setLoading(true);
//         const res = await fetchData({ month, year, dist_code, afso_code, fps_id });

//         setHeading(res.heading || "");

//         if (res.data) {
//           setData(res.data);
//           setColumns(getColumns(res.data));
//         }

//       } catch (e) {
//         console.error(e);
//       } finally {
//         setLoading(false);
//       }
//     };

//     load();
//   }, [month, year, dist_code, afso_code, fps_id]);

//   //  Search Filter
//   const filteredData = useMemo(() => {
//     if (!search) return data;

//     const q = search.toLowerCase();

//     return data.filter(row =>
//       (row.rc_id || "").toLowerCase().includes(q) ||
//       (row.family_head || "").toLowerCase().includes(q) ||
//       (row.scheme_name_en || "").toLowerCase().includes(q)
//     );
//   }, [data, search]);

//   // Reset page when searching
//   useEffect(() => {
//     setPage(0);
//   }, [search]);

//   //  Pagination
//   const paginatedData = useMemo(() => {
//     if (rowsPerPage === -1) return filteredData;

//     const start = page * rowsPerPage;
//     return filteredData.slice(start, start + rowsPerPage);
//   }, [filteredData, page, rowsPerPage]);

//   // Totals (filtered data)
//   const { totals, totalUnits } = useMemo(() => {
//     const totals = {};
//     columns.forEach(col => totals[col] = 0);

//     let totalUnits = 0;

//     filteredData.forEach(row => {
//       totalUnits += row.units || 0;

//       columns.forEach(col => {
//         totals[col] += Number(row[col] ?? 0);
//       });
//     });

//     return { totals, totalUnits };
//   }, [filteredData, columns]);

//   //  Pagination handlers
//   const handleChangePage = (_, newPage) => setPage(newPage);

//   const handleChangeRowsPerPage = (value) => {
//     setRowsPerPage(value === 'all' ? -1 : parseInt(value, 10));
//     setPage(0);
//   };

//   //  Loading
//   if (loading) {
//     return (
//       <Box textAlign="center">
//         <CircularProgress />
//       </Box>
//     );
//   }

//   return (
//     <>
//       {/*  Search + Pagination */}
//       <div style={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         width: '90%',
//         margin: '20px auto'
//       }}>

//         <PaginationTable
//           count={filteredData.length}
//           rowsPerPage={rowsPerPage === -1 ? filteredData.length : rowsPerPage}
//           page={page}
//           onPageChange={handleChangePage}
//           onRowsPerPageChange={handleChangeRowsPerPage}
//         />

//         <input
//           type="text"
//           placeholder="Search RC / Name / Scheme"
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//           style={{ padding: '8px', width: '300px' }}
//         />
//       </div>

//       <table border="1" width="90%" align="center" style={{ borderCollapse: 'collapse' }}>
//         <thead>
//           {/* Title */}
//           <tr className="tableheader">
//             <th colSpan={5 + columns.length}>{heading}</th>
//           </tr>

//           {/* Main Header */}
//           <tr className="tableheader">
//             <th rowSpan={2}>Sl.No</th>
//             <th rowSpan={2}>RC Id</th>
//             <th rowSpan={2}>Family Head</th>
//             <th rowSpan={2}>Scheme</th>
//             <th rowSpan={2}>Units</th>

//             <th colSpan={columns.length}>Entitlement</th>
//           </tr>

//           {/* Sub Header (NO EMPTY COLSPAN HERE) */}
//           <tr className="tableheader">
//             {columns.map((col, i) => (
//               <th key={i}>{col}</th>
//             ))}
//           </tr>
//         </thead>

//         <tbody>
//           {paginatedData.length > 0 ? (
//             paginatedData.map((row, i) => (
//               <tr key={i}>
//                 <td>{i + 1 + page * (rowsPerPage === -1 ? 0 : rowsPerPage)}</td>
//                 <td>{row.rc_id}</td>
//                 <td>{row.family_head}</td>
//                 <td>{row.scheme_name_en}</td>
//                 <td>{row.units}</td>

//                 {columns.map((col, idx) => (
//                   <td key={idx} style={{ textAlign: 'right' }}>
//                     {row[col] ?? 0}
//                   </td>
//                 ))}
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td colSpan={5 + columns.length} style={{ textAlign: 'center', padding: '20px' }}>
//                  No Data Found for "{search}"
//               </td>
//             </tr>
//           )}

//           {paginatedData.length > 0 && (
//             <tr  className='tableheader' style={{ fontWeight: 'bold', background: '#f2f2f2' }}>
//               <td colSpan={4}>Total</td>
//               <td>{totalUnits}</td>

//               {columns.map((col, idx) => (
//                 <td key={idx} style={{ textAlign: 'right' }}>
//                   {totals[col]}
//                 </td>
//               ))}
//             </tr>
//           )}
//         </tbody>
//       </table>
//     </>
//   );
// };

// export default KeyRegisterTable; 


//===================================================


import React, { useEffect, useState, useMemo } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import PaginationTable from '../../pagination/Pagination4';

const fetchData = async (params) => {
  const res = await fetch(
    `${process.env.REACT_APP_URL_ALLOTMENT}/KeyRegister/getfpsKeyRegisterCardsList`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    }
  );

  if (!res.ok) throw new Error("API Error");
  return res.json();
};

const KeyRegisterTable = ({ month, year, dist_code, afso_code, fps_id }) => {

  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [heading, setHeading] = useState("");
  const [loading, setLoading] = useState(true);

  // Pagination + Search
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [search, setSearch] = useState("");

  // FIXED: Dynamic Commodity Columns
  const getColumns = (data) => {
    const cols = new Set();

    data.forEach(row => {
      Object.keys(row).forEach(key => {
        if (
          !["rc_id", "units", "family_head", "scheme_name_en"].includes(key)
        ) {
          cols.add(key);
        }
      });
    });

    return Array.from(cols);
  };

  // Fetch API
  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const res = await fetchData({ month, year, dist_code, afso_code, fps_id });

        setHeading(res.heading || "");

        if (res.data) {
          setData(res.data);
          setColumns(getColumns(res.data));
        }

      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [month, year, dist_code, afso_code, fps_id]);

  // Search Filter
  const filteredData = useMemo(() => {
    if (!search) return data;

    const q = search.toLowerCase();

    return data.filter(row =>
      (row.rc_id || "").toLowerCase().includes(q) ||
      (row.family_head || "").toLowerCase().includes(q) ||
      (row.scheme_name_en || "").toLowerCase().includes(q)
    );
  }, [data, search]);

  // Reset page when searching
  useEffect(() => {
    setPage(0);
  }, [search]);

  // Pagination
  const paginatedData = useMemo(() => {
    if (rowsPerPage === -1) return filteredData;

    const start = page * rowsPerPage;
    return filteredData.slice(start, start + rowsPerPage);
  }, [filteredData, page, rowsPerPage]);

  // Totals
  const { totals, totalUnits } = useMemo(() => {
    const totals = {};
    columns.forEach(col => totals[col] = 0);

    let totalUnits = 0;

    filteredData.forEach(row => {
      totalUnits += row.units || 0;

      columns.forEach(col => {
        totals[col] += Number(row[col] ?? 0);
      });
    });

    return { totals, totalUnits };
  }, [filteredData, columns]);

  // Pagination handlers
  const handleChangePage = (_, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value === 'all' ? -1 : parseInt(value, 10));
    setPage(0);
  };

  // Loading
  if (loading) {
    return (
      <Box textAlign="center">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      {/* Search + Pagination */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '90%',
        margin: '20px auto'
      }}>

        <PaginationTable
          count={filteredData.length}
          rowsPerPage={rowsPerPage === -1 ? filteredData.length : rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        <input
          type="text"
          placeholder="Search RC / Name / Scheme"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ padding: '8px', width: '300px' }}
        />
      </div>

      {/* Table */}
      <table border="1" width="90%" align="center" style={{ borderCollapse: 'collapse' }}>

        <thead>
          {/* Title */}
          <tr className="tableheader">
            <th colSpan={5 + columns.length}>{heading}</th>
          </tr>

          {/* Main Header */}
          <tr className="tableheader">
            <th rowSpan={2}>Sl.No</th>
            <th rowSpan={2}>RC Id</th>
            <th rowSpan={2}>Family Head</th>
            <th rowSpan={2}>Scheme</th>
            <th rowSpan={2}>Units</th>

            <th colSpan={columns.length}>Entitlement</th>
          </tr>

          {/* Sub Header */}
          <tr className="tableheader">
            {columns.map((col, i) => (
              <th key={i}>
                {col} </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {paginatedData.length > 0 ? (
            paginatedData.map((row, i) => (
              <tr key={i}>
                <td>{i + 1 + page * (rowsPerPage === -1 ? 0 : rowsPerPage)}</td>
                <td>{row.rc_id}</td>
                <td>{row.family_head}</td>
                <td>{row.scheme_name_en}</td>
                <td>{row.units}</td>

                {columns.map((col, idx) => (
                  <td key={idx} style={{ textAlign: 'right' }}>
                    {row[col] ?? 0}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5 + columns.length} style={{ textAlign: 'center', padding: '20px' }}>
                No Data Found for "{search}"
              </td>
            </tr>
          )}

          {/* Totals */}
          {paginatedData.length > 0 && (
            <tr className="tableheader" style={{ fontWeight: 'bold' }}>
              <td colSpan={5}>Total</td>
              {/* <td>{totalUnits}</td> */}

              {columns.map((col, idx) => (
                <td key={idx} style={{ textAlign: 'right' }}>
                  {totals[col]}
                </td>
              ))}
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

export default KeyRegisterTable;